import { Breadcrumb, Button, Card, Divider, Form, Modal, Select } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { accountListSelector } from "../../store/selectors/app.selector";
import { ReactComponent as RadioCheckIcon }  from "../../assests/images/radioCheck.svg";
import { IoRadioButtonOff } from "react-icons/io5";
import AccountService from "../../services/accounts.service";
import { ReactComponent as TitleIcon } from "../../assests/images/settingsBreadCum.svg";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { PatternFormat } from "react-number-format";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

const defaultType = {
  week: false,
  month: false,
  quator: false,
  everyDay: false,
  everyWeek: false,
};

export default function EStamentRequest() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [stopLoader, setStopLoader] = useState(false);
  const [accountDetails, setAccountDetails] = useState({});
  const accountList = useSelector(accountListSelector);
  const [form] = Form.useForm();
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [existingDetails, setExistingDetails] = useState([]);
  const { t } = useTranslation();
  const [frequency, setFrequency] = useState({
    week: false,
    month: false,
    quator: false,
    everyDay: false,
    everyWeek: false,
  });

  useEffect(() => {
    if (accountList.length > 0) {
      setAccountDetails(accountList[0]);
      getEStatementsDetails(accountList[0]);
      form.setFieldsValue({ accountNo: accountList[0]?.accountNo });
    }
  }, [accountList]);

  const handleChange = useCallback((type, value) => {
    try {
      setFrequency({ ...defaultType, [type]: true });
    } catch (error) {}
  }, []);

  const getEStatementsDetails = useCallback(async (data) => {
    try {
      setPageLoader(true);
      const response = await AccountService.getEStatementsDetails({});
      if (response.status === 200) {
        setPageLoader(false);
        setDataSource(response.data["data"]);
        setExistingDetails(
          response.data["data"].filter(
            (ele) => ele.accountNumber === data.accountNo
          )
        );
      }
    } catch (error) {
      setPageLoader(false);
    }
  }, []);

  const onFinish = useCallback(
    async (values) => {
      try {
        if (!Object.values(frequency).includes(true)) {
          return;
        }
        const eDetails = dataSource?.find(
          (ele) => ele.accountNumber === values?.accountNo
        );
        const accDetails = accountList.find(
          (ele) => ele.accountNo === values?.accountNo
        );
        console.log("accDetails", accDetails);
        const reqParams = {
          accountNumber: values?.accountNo,
          branchId: accDetails?.acctBranchID,
          everyWeek: frequency.week,
          everyMonth: frequency.month,
          everyQuarter: frequency.quator,
          everyDayCumulative: frequency.everyDay,
          everyWeekCumulative: frequency.everyWeek,
          stopRequest: false,
          id: eDetails?.id || null,
        };
        setLoader(true);
        const response = await AccountService.raiseEStatementRequest(reqParams);
        if (response.status === 200) {
          setLoader(false);
          setMessage(response.data["message"]);
          setVisible(true);
        }
      } catch (error) {
        setLoader(false);
      }
    },
    [frequency, dataSource, accountList]
  );

  const requestforEStatement = useCallback(async () => {
    try {
      const reqParams = {
        accountNumber: accountDetails?.accountNo,
        branchId: accountDetails?.acctBranchID,
        everyWeek: false,
        everyMonth: false,
        everyQuarter: false,
        everyDayCumulative: false,
        everyWeekCumulative: false,
        stopRequest: true,
        id: existingDetails[0]?.id || null,
      };
      setStopLoader(true);
      const response = await AccountService.raiseEStatementRequest(reqParams);
      if (response.status === 200) {
        setStopLoader(false);
        setMessage(response.data["message"]);
        setVisible(true);
      }
    } catch (error) {
      setStopLoader(false);
    }
  }, [accountDetails, existingDetails]);

  const handleAccNoChange = useCallback(
    (value) => {
      try {
        setAccountDetails(accountList.find((ele) => ele.accountNo === value));
        setExistingDetails(
          dataSource.filter((ele) => ele.accountNumber === value)
        );
      } catch (error) {}
    },
    [accountList, dataSource]
  );

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/request")}>
              {t("navigation.request", {
                defaultValue: "Service Request",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("pages.my_accounts.casa.eStatement_Request", {
                defaultValue: "eStatement Request",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("pages.my_accounts.casa.eStatement_Request", {
                defaultValue: "eStatement Request",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-10 col-lg-8">
          <Card style={{ minHeight: 300 }} className="application-card col-12">
            <Form layout="vertical" form={form} onFinish={onFinish}>
              <div className="row">
                <div className="col-8 col-sm-6 col-md-5 col-lg-5">
                  <Form.Item
                    label={t("common.account_no_lbl", {
                      defaultValue: "Account Number",
                    })}
                    name="accountNo"
                  >
                    <Select
                      placeholder={t("common.account_no_lbl", {
                        defaultValue: "Account Number",
                      })}
                      onChange={handleAccNoChange}
                      optionLabelProp={"value"}
                      size="large"
                    >
                      {accountList?.map((option, idx) => (
                        <Select.Option key={idx} value={option.accountNo}>
                          <span style={{ fontWeight: "bold" }}>
                            {option?.acctShortName}
                          </span>
                          <br />
                          <span style={{ fontSize: "12px" }}>
                            {option?.accountNo}
                          </span>
                          <br />
                          <span style={{ fontSize: "12px" }}>
                            {option?.branchName}
                          </span>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div>
                  <p>
                    {t("pages.my_accounts.casa.frequency_txt", {
                      defaultValue:
                        "Please select a frequency to start receiving your eStatement",
                    })}
                    :{" "}
                    <PatternFormat
                      value={accountDetails?.accountNo}
                      displayType="text"
                      format="#### #### #### ###"
                    />
                  </p>

                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3">
                      <div
                        className="d-flex align-items-center"
                        onClick={() => handleChange("week", frequency.week)}
                      >
                        <span style={{ marginRight: 5 }}>
                          {!frequency.week && (
                            <IoRadioButtonOff style={{ fontSize: 20 }} />
                          )}
                          {frequency.week && (
                            <RadioCheckIcon height={17} width={17} />
                          )}
                        </span>
                        <span>
                          {t("pages.my_accounts.casa.every_week", {
                            defaultValue: "Every Week",
                          })}
                        </span>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3">
                      <div
                        className="d-flex"
                        onClick={() => handleChange("month", frequency.month)}
                      >
                        <span style={{ marginRight: 5 }}>
                          {!frequency.month && (
                            <IoRadioButtonOff style={{ fontSize: 20 }} />
                          )}
                          {frequency.month && (
                            <RadioCheckIcon height={17} width={17} />
                          )}
                        </span>
                        <span>
                          {t("pages.my_accounts.casa.every_month", {
                            defaultValue: "Every Month",
                          })}
                        </span>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 mb-3">
                      <div
                        className="d-flex"
                        onClick={() => handleChange("quator", frequency.quator)}
                      >
                        <span style={{ marginRight: 5 }}>
                          {!frequency.quator && (
                            <IoRadioButtonOff style={{ fontSize: 20 }} />
                          )}
                          {frequency.quator && (
                            <RadioCheckIcon height={17} width={17} />
                          )}
                        </span>
                        <span>
                          {t("pages.my_accounts.casa.every_quarter", {
                            defaultValue: "Every Quarter",
                          })}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                  <div
                    className="d-flex"
                    onClick={() => handleChange("everyDay", frequency.everyDay)}
                  >
                    <span style={{ marginRight: 10, paddingTop: 5 }}>
                      {!frequency.everyDay && (
                        <IoRadioButtonOff style={{ fontSize: 20 }} />
                      )}
                      {frequency.everyDay && (
                        <RadioCheckIcon height={17} width={17} />
                      )}
                    </span>
                    <span>
                      <span>
                        {t("pages.my_accounts.casa.every_day_cumulative", {
                          defaultValue: "Every day - Cumulative",
                        })}
                      </span>
                      <p>
                        {t("pages.my_accounts.casa.selecting_txt", {
                          defaultValue:
                            "On selecting this, you will receive incremental records in your statements every day starting from 1st of month",
                        })}
                      </p>
                    </span>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                  <div
                    className="d-flex"
                    onClick={() =>
                      handleChange("everyWeek", frequency.everyWeek)
                    }
                  >
                    <span style={{ marginRight: 10, paddingTop: 5 }}>
                      {!frequency.everyWeek && (
                        <IoRadioButtonOff style={{ fontSize: 20 }} />
                      )}
                      {frequency.everyWeek && (
                        <RadioCheckIcon height={17} width={17} />
                      )}
                    </span>
                    <span>
                      <span>
                        {t("pages.my_accounts.casa.every_week_cumulative", {
                          defaultValue: "Every week - Cumulative",
                        })}
                      </span>
                      <p>
                        {t("pages.my_accounts.casa.selecting_week_txt", {
                          defaultValue:
                            "On selecting this, you will receive incremental records in your statements every week starting from 1st of month",
                        })}
                      </p>
                    </span>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between mt-5">
              <Button
                loading={loader}
                type="primary"
                htmlType="submit"
                size="large"
                disabled={!Object.values(frequency).includes(true)}
                className=""
              >
                {existingDetails.length > 0
                  ? t("pages.my_accounts.casa.req_update_estmt_btn", {
                      defaultValue: "Request for Update eStatement",
                    })
                  : t("pages.my_accounts.casa.req_estmt_btn", {
                      defaultValue: "Request for eStatement",
                    })}
              </Button>
              {existingDetails.length > 0 && (
                <Button
                  loading={stopLoader}
                  onClick={() => requestforEStatement()}
                  size="large"
              className="secondary-btn"
                >
                  {t("pages.my_accounts.casa.stop_estmt_req_btn", {
                    defaultValue: "Stop eStatement Request",
                  })}
                </Button>
              )}
              </div>
              
            </Form>
          </Card>
        </div>
      </div>

      <Modal
        title={""}
        open={visible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <h3 className="primary-title">
          {t("pages.my_accounts.casa.eStatement_Request", {
            defaultValue: "eStatement Request",
          })}
        </h3>
        <p style={{ marginBottom: 30, fontSize: 15 }}>{message}</p>
        <div align="right" className="mt-3">
          <Button
            type="link"
            onClick={() => {
              setVisible(false);
              navigate("/settings");
            }}
          >
            {t("buttons.okay_btn", {
              defaultValue: "Okay",
            })}
          </Button>
        </div>
      </Modal>
    </>
  );
}
